import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';

import RouteComponent from './routes/routeComponent';
import { store } from './redux/configureStore';
import { msalInstance } from './shared/config/msalConfig';
import DatadogUserIdentify from './components/DatadogUserIdentify';

function App() {
    return (
        <MsalProvider instance={msalInstance}>
            <DatadogUserIdentify />
            <ReduxProvider store={store}>
                <RouteComponent />
            </ReduxProvider>
        </MsalProvider>
    );
}

export default App;
